import { connect, addSuccess, closeModal, setScoreReconciliation, toggleRegradingEditMode, createQuizEntryRegrade } from '@instructure/quiz-core';
import { REGRADE_MODAL } from '@instructure/quiz-common';
import RegradingModalPresenter from './presenter';
export var mapStateToProps = function mapStateToProps(state) {
  return {
    modalOpen: state.getIn(['modal', 'isOpen']) === REGRADE_MODAL,
    regradingPayload: state.getIn(['regrading', 'regradingPayload']),
    scoreReconciliation: state.getIn(['regrading', 'scoreReconciliation'])
  };
};
var mapDispatchToProps = {
  addSuccess: addSuccess,
  closeModal: closeModal,
  createQuizEntryRegrade: createQuizEntryRegrade,
  setScoreReconciliation: setScoreReconciliation,
  toggleRegradingEditMode: toggleRegradingEditMode
};
export var RegradingModal = connect(mapStateToProps, mapDispatchToProps)(RegradingModalPresenter);
export default RegradingModal;